module.exports = __webpack_public_path__ + "723aa4d8aa73f5c5576e23e697b1015d.svg";